import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {CheckboxTable} from '../../../tools/checkbox-table/checkbox-table';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-checkbox-table',
  imports: [
    FormsModule
  ],
  templateUrl: './checkbox-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './checkbox-table.component.scss'
})
export class CheckboxTableComponent {
  @Input() value: any;
  @Input() checked: boolean = false;

  private checkboxTable: CheckboxTable | null = null;

  setCheckboxTable(checkboxTable: CheckboxTable | null): void {
    this.checkboxTable = checkboxTable;
    this.checkboxTable?.registerCheckboxTableComponents(this);
  }

  onChanged(): void {
    if (this.checkboxTable) {
      this.checkboxTable.update();
    }
  }
}
